import { createMuiTheme } from "@material-ui/core/styles";
import { ThemePrimaryColor } from "../utilities/colors";

export function colorTheme() {
  let theme = createMuiTheme({
    palette: {
      primary: {
        main: ThemePrimaryColor,
      },
    },
  });
  return theme;
}
